export const progressTheme = {
    spinnerVariant: {
        thin: 8,
        thick: 2.5,
    },
};
export const spinnerVariant = (variant) => progressTheme.spinnerVariant[variant ?? 'thin'];
//# sourceMappingURL=theme.js.map